// hooks/useReportFilters.js
import { useState } from 'react';
import moment from 'moment';

export const useReportFilters = () => {
  const [searchDestination, setSearchDestination] = useState("");
  const [filters, setFilters] = useState({
    callDirection: "",
    didNumber: "",
    destination: "",
    callerId: "",
    status: "",
    durationOp: ">=",
    durationValue: "",
    uniqueOnly: false,
  });
  
  const [fromDate, setFromDate] = useState(moment().startOf('day'));
  const [toDate, setToDate] = useState(moment().endOf('day'));

  const handleFromDateChange = (date) => {
    if (!moment.isMoment(date)) {
      setFromDate(null);
      return;
    }

    const previous = fromDate;
    if (!previous || !moment.isMoment(previous)) {
      const now = moment();
      const updated = date
        .hour(now.hour())
        .minute(now.minute())
        .second(now.second());
      setFromDate(updated);
      return;
    }

    const isDateChanged = !date.isSame(previous, "day");
    const isTimeSame =
      date.hour() === previous.hour() && date.minute() === previous.minute();

    if (isDateChanged && isTimeSame) {
      const now = moment();
      const updated = date
        .hour(now.hour())
        .minute(now.minute())
        .second(now.second());
      setFromDate(updated);
    } else {
      setFromDate(date);
    }
  };

  const handleToDateChange = (date) => {
    if (!date || !moment.isMoment(date)) {
      setToDate(null);
      return;
    }

    if (!toDate || !moment.isMoment(toDate)) {
      const now = moment();
      setToDate(
        date.clone().hour(now.hour()).minute(now.minute()).second(now.second())
      );
      return;
    }

    const isDateChanged = !date.isSame(toDate, "day");
    const isTimeSame =
      date.hour() === toDate.hour() && date.minute() === toDate.minute();

    if (isDateChanged && isTimeSame) {
      const now = moment();
      const updated = date
        .hour(now.hour())
        .minute(now.minute())
        .second(now.second());
      setToDate(updated);
    } else {
      setToDate(date);
    }
  };

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  const resetFilters = () => {
    setFilters({
      callDirection: "",
      didNumber: "",
      destination: "",
      callerId: "",
      status: "",
      durationOp: ">=",
      durationValue: "",
      uniqueOnly: false,
    });
    setFromDate(moment().startOf('day'));
    setToDate(moment().endOf('day'));
  };

  return {
    searchDestination,
    setSearchDestination,
    filters,
    fromDate,
    toDate,
    handleFromDateChange,
    handleToDateChange,
    handleFilterChange,
    resetFilters,
  };
};